export default __webpack_public_path__ + "static/media/open-pay.d71d952a.webp";